import { defineStore } from "pinia"
import { ref } from "vue"

export type NotificationType = "error" | "success"

export interface Notification {
    message: string
    type: NotificationType
    duration: number
}

const DEFAULT_DURATION = 5000

export const useNotificationStore = defineStore("notification", () => {
    const current = ref<Notification>()

    const showError = (message: string, duration: number = DEFAULT_DURATION) => {
        current.value = { message, type: "error", duration }
    }

    const showSuccess = (message: string, duration: number = DEFAULT_DURATION) => {
        current.value = { message, type: "success", duration }
    }

    const dismiss = () => {
        current.value = undefined
    }

    return {
        current,
        showError,
        showSuccess,
        dismiss
    }
})
